module.exports = __webpack_public_path__ + "img/google_play.debb501f.png";